import * as appSelectors from 'app/state/app/app-selectors';
import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';
import { parseBoolean } from 'utils/parse-boolean';

export function useIsCCActive() {
  const activeFlow = useSelector(appSelectors.activeFlow);
  const flows = useSelector(appSelectors.flows);
  // If isCCActive is not defined, then it is assumed CC is active
  const isCCActive = !isUndefined(flows[activeFlow]?.isCCActive) ? parseBoolean(flows[activeFlow]?.isCCActive) : true;

  return isCCActive;
}

export function useIsACHActive() {
  const activeFlow = useSelector(appSelectors.activeFlow);
  const flows = useSelector(appSelectors.flows);
  // If isCCActive is not defined, then it is ACH is active
  const isACHActive = !isUndefined(flows[activeFlow]?.isACHActive) ? parseBoolean(flows[activeFlow]?.isACHActive) : true;

  return isACHActive;
}
